<div *ngIf="!plan" class="not-found">
  <mat-icon>error_outline</mat-icon>
  <h2>Plan not found</h2>
  <button mat-raised-button color="primary" (click)="goBack()">Back to Home</button>
</div>

<div *ngIf="plan" class="detail-page">

  <!-- Hero -->
  <div class="plan-hero">
    <button mat-icon-button class="back-btn" (click)="goBack()" matTooltip="Back to home">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="hero-inner">
      <div class="hero-badge" *ngIf="plan.badge">{{ plan.badge }}</div>
      <h1 class="hero-plan-name">{{ plan.name }}</h1>
      <div class="hero-price">
        {{ plan.price }}
        <span class="hero-period">{{ plan.period }}</span>
      </div>
      <p class="hero-tagline">{{ plan.tagline }}</p>
      <button class="hero-cta" (click)="cta()" [disabled]="isSelfServeTier && isCurrentPlan">{{ ctaButtonLabel }}</button>
      <p class="hero-note" *ngIf="isSelfServeTier && !isCurrentPlan">14 days free · Cancel anytime</p>
    </div>
  </div>

  <!-- Body -->
  <div class="detail-body">

    <!-- Description -->
    <section class="detail-section">
      <p class="plan-description">{{ plan.description }}</p>
    </section>

    <!-- Features -->
    <section class="detail-section">
      <h2 class="section-heading">What's Included</h2>
      <div class="feature-groups">
        <div class="feature-group" *ngFor="let group of plan.featureGroups">
          <div class="feature-group-heading">
            <mat-icon class="fg-icon">check_circle</mat-icon>
            {{ group.heading }}
          </div>
          <ul class="feature-list">
            <li *ngFor="let item of group.items">{{ item }}</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Who It's For -->
    <section class="detail-section who-section">
      <h2 class="section-heading">Who It's For</h2>
      <div class="who-grid">
        <div class="who-card" *ngFor="let w of plan.whoFor">
          <mat-icon class="who-icon">person_outline</mat-icon>
          <span>{{ w }}</span>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section class="detail-section faq-section">
      <h2 class="section-heading">Frequently Asked Questions</h2>
      <div class="faq-list">
        <div class="faq-item" *ngFor="let faq of plan.faqs; let i = index"
             [class.faq-open]="openFaq === i">
          <div class="faq-question" (click)="toggleFaq(i)">
            <span>{{ faq.q }}</span>
            <mat-icon>{{ openFaq === i ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
          <div class="faq-answer" *ngIf="openFaq === i">{{ faq.a }}</div>
        </div>
      </div>
    </section>

    <!-- Other plans -->
    <section class="detail-section other-plans-section">
      <h2 class="section-heading">Compare Other Plans</h2>
      <div class="other-plan-cards">
        <div class="other-plan-card" *ngFor="let other of otherPlans" (click)="goToPlan(other.id)">
          <div class="op-name">{{ other.name }}</div>
          <div class="op-price">{{ other.price }} <span class="op-period">{{ other.period }}</span></div>
          <p class="op-tagline">{{ other.tagline }}</p>
          <span class="op-link">View details →</span>
        </div>
      </div>
    </section>

    <!-- Bottom CTA -->
    <section class="bottom-cta">
      <h2>Ready to get started with {{ plan.name }}?</h2>
      <p>No hidden fees. Cancel anytime.</p>
      <button class="hero-cta bottom-cta-btn" (click)="cta()" [disabled]="isSelfServeTier && isCurrentPlan">{{ ctaButtonLabel }}</button>
    </section>

  </div>
</div>
